import { createFileRoute, Outlet } from '@tanstack/react-router';

import { PublicChrome } from '../components/PublicChrome';

/**
 * Pathless layout (`_public`) for the unauthenticated catalog: it contributes chrome without adding a
 * URL segment, so the routes beneath keep their original paths — `/`, `/components`, `/resources`.
 */
export const Route = createFileRoute('/_public')({
  component: PublicLayout,
});

function PublicLayout() {
  return (
    <PublicChrome>
      <Outlet />
    </PublicChrome>
  );
}
